export default __webpack_public_path__ + "static/media/default-monochrome.e6ef8fd1.svg";